// Module
var code = "<p> <label>Subdivisions</label> <input type=\"range\" min=\"0\" max=\"5\" step=\"1\" oninput=\"subdivide.p.subdivisions.set(event.target.value)\"> </p>";
// Exports
export default code;